"use client";

export default function AnimatedCodeGraph() {
  return (
    <svg viewBox="0 0 400 300" className="w-full h-auto">
      <defs>
        <linearGradient id="graphEdge" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#4b5563" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
      </defs>

      {/* Edges with random highlighting */}
      <g strokeWidth="2.5" fill="none">
        {/* Top layer connections */}
        <line x1="80" y1="40" x2="200" y2="30" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4s" repeatCount="indefinite" />
        </line>
        <line x1="80" y1="40" x2="130" y2="90" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="5s" begin="0.5s" repeatCount="indefinite" />
        </line>
        <line x1="200" y1="30" x2="320" y2="50" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.5s" begin="1s" repeatCount="indefinite" />
        </line>
        <line x1="200" y1="30" x2="270" y2="90" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="3.8s" begin="1.2s" repeatCount="indefinite" />
        </line>

        {/* Middle layer connections */}
        <line x1="130" y1="90" x2="200" y2="120" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.2s" begin="1.5s" repeatCount="indefinite" />
        </line>
        <line x1="130" y1="90" x2="60" y2="150" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.7s" begin="2s" repeatCount="indefinite" />
        </line>
        <line x1="270" y1="90" x2="200" y2="120" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="3.9s" begin="2.3s" repeatCount="indefinite" />
        </line>
        <line x1="270" y1="90" x2="340" y2="140" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.4s" begin="1.8s" repeatCount="indefinite" />
        </line>
        <line x1="320" y1="50" x2="340" y2="140" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="5s" begin="0.8s" repeatCount="indefinite" />
        </line>

        {/* Lower middle layer */}
        <line x1="200" y1="120" x2="150" y2="180" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.1s" begin="2.5s" repeatCount="indefinite" />
        </line>
        <line x1="200" y1="120" x2="250" y2="180" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.6s" begin="2.8s" repeatCount="indefinite" />
        </line>
        <line x1="60" y1="150" x2="150" y2="180" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.3s" begin="3s" repeatCount="indefinite" />
        </line>
        <line x1="340" y1="140" x2="250" y2="180" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.8s" begin="1.3s" repeatCount="indefinite" />
        </line>

        {/* Bottom layer connections */}
        <line x1="60" y1="150" x2="90" y2="240" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.5s" begin="3.2s" repeatCount="indefinite" />
        </line>
        <line x1="150" y1="180" x2="200" y2="260" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="3.7s" begin="3.5s" repeatCount="indefinite" />
        </line>
        <line x1="250" y1="180" x2="200" y2="260" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4s" begin="3.8s" repeatCount="indefinite" />
        </line>
        <line x1="250" y1="180" x2="310" y2="240" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.9s" begin="4s" repeatCount="indefinite" />
        </line>
        <line x1="90" y1="240" x2="200" y2="260" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="3.6s" begin="4.2s" repeatCount="indefinite" />
        </line>
        <line x1="310" y1="240" x2="200" y2="260" stroke="url(#graphEdge)" opacity="0.6">
          <animate attributeName="opacity" values="0.4;0.9;0.4" dur="4.2s" begin="4.5s" repeatCount="indefinite" />
        </line>
      </g>

      {/* Flowing particles on edges */}
      <g>
        <circle r="3" fill="#06b6d4">
          <animateMotion dur="5s" repeatCount="indefinite">
            <mpath href="#path1" />
          </animateMotion>
        </circle>
        <circle r="3" fill="#4b5563">
          <animateMotion dur="6s" begin="0.5s" repeatCount="indefinite">
            <mpath href="#path2" />
          </animateMotion>
        </circle>
        <circle r="3" fill="#10b981">
          <animateMotion dur="5.5s" begin="1s" repeatCount="indefinite">
            <mpath href="#path3" />
          </animateMotion>
        </circle>
        <circle r="3" fill="#f59e0b">
          <animateMotion dur="6.5s" begin="1.5s" repeatCount="indefinite">
            <mpath href="#path4" />
          </animateMotion>
        </circle>
        <circle r="3" fill="#ef4444">
          <animateMotion dur="5.8s" begin="2s" repeatCount="indefinite">
            <mpath href="#path5" />
          </animateMotion>
        </circle>
      </g>

      {/* Hidden paths for particle motion */}
      <defs>
        <path id="path1" d="M80,40 L200,30 L320,50" />
        <path id="path2" d="M80,40 L130,90 L200,120 L200,260" />
        <path id="path3" d="M320,50 L340,140 L250,180 L200,260" />
        <path id="path4" d="M200,30 L270,90 L200,120 L150,180 L200,260" />
        <path id="path5" d="M130,90 L60,150 L90,240 L200,260" />
      </defs>

      {/* Nodes with slow random movement */}
      <g>
        {/* Top layer nodes */}
        <circle cx="80" cy="40" r="14" fill="#4b5563">
          <animate attributeName="cx" values="80;78;82;80" dur="8s" repeatCount="indefinite" />
          <animate attributeName="cy" values="40;42;38;40" dur="7s" repeatCount="indefinite" />
        </circle>
        <text x="80" y="45" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">
          <animate attributeName="x" values="80;78;82;80" dur="8s" repeatCount="indefinite" />
          <animate attributeName="y" values="45;47;43;45" dur="7s" repeatCount="indefinite" />
          fn
        </text>

        <circle cx="200" cy="30" r="16" fill="#06b6d4">
          <animate attributeName="cx" values="200;198;202;200" dur="9s" repeatCount="indefinite" />
          <animate attributeName="cy" values="30;32;28;30" dur="8s" begin="0.5s" repeatCount="indefinite" />
        </circle>
        <text x="200" y="35" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">
          <animate attributeName="x" values="200;198;202;200" dur="9s" repeatCount="indefinite" />
          <animate attributeName="y" values="35;37;33;35" dur="8s" begin="0.5s" repeatCount="indefinite" />
          main
        </text>

        <circle cx="320" cy="50" r="14" fill="#10b981">
          <animate attributeName="cx" values="320;318;322;320" dur="7.5s" repeatCount="indefinite" />
          <animate attributeName="cy" values="50;52;48;50" dur="8.5s" begin="1s" repeatCount="indefinite" />
        </circle>
        <text x="320" y="55" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="320;318;322;320" dur="7.5s" repeatCount="indefinite" />
          <animate attributeName="y" values="55;57;53;55" dur="8.5s" begin="1s" repeatCount="indefinite" />
          api
        </text>

        {/* Upper middle layer */}
        <circle cx="130" cy="90" r="14" fill="#f59e0b">
          <animate attributeName="cx" values="130;128;132;130" dur="8.5s" repeatCount="indefinite" />
          <animate attributeName="cy" values="90;92;88;90" dur="7.5s" begin="0.3s" repeatCount="indefinite" />
        </circle>
        <text x="130" y="95" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="130;128;132;130" dur="8.5s" repeatCount="indefinite" />
          <animate attributeName="y" values="95;97;93;95" dur="7.5s" begin="0.3s" repeatCount="indefinite" />
          cls
        </text>

        <circle cx="270" cy="90" r="14" fill="#4b5563">
          <animate attributeName="cx" values="270;268;272;270" dur="7s" repeatCount="indefinite" />
          <animate attributeName="cy" values="90;92;88;90" dur="9s" begin="0.7s" repeatCount="indefinite" />
        </circle>
        <text x="270" y="95" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="270;268;272;270" dur="7s" repeatCount="indefinite" />
          <animate attributeName="y" values="95;97;93;95" dur="9s" begin="0.7s" repeatCount="indefinite" />
          fn
        </text>

        {/* Middle layer */}
        <circle cx="60" cy="150" r="14" fill="#06b6d4">
          <animate attributeName="cx" values="60;58;62;60" dur="8.2s" repeatCount="indefinite" />
          <animate attributeName="cy" values="150;152;148;150" dur="7.8s" begin="0.4s" repeatCount="indefinite" />
        </circle>
        <text x="60" y="155" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="60;58;62;60" dur="8.2s" repeatCount="indefinite" />
          <animate attributeName="y" values="155;157;153;155" dur="7.8s" begin="0.4s" repeatCount="indefinite" />
          db
        </text>

        <circle cx="200" cy="120" r="15" fill="#10b981">
          <animate attributeName="cx" values="200;198;202;200" dur="7.3s" repeatCount="indefinite" />
          <animate attributeName="cy" values="120;122;118;120" dur="8.7s" begin="0.6s" repeatCount="indefinite" />
        </circle>
        <text x="200" y="125" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">
          <animate attributeName="x" values="200;198;202;200" dur="7.3s" repeatCount="indefinite" />
          <animate attributeName="y" values="125;127;123;125" dur="8.7s" begin="0.6s" repeatCount="indefinite" />
          fn
        </text>

        <circle cx="340" cy="140" r="14" fill="#f59e0b">
          <animate attributeName="cx" values="340;338;342;340" dur="8.8s" repeatCount="indefinite" />
          <animate attributeName="cy" values="140;142;138;140" dur="7.2s" begin="0.8s" repeatCount="indefinite" />
        </circle>
        <text x="340" y="145" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="340;338;342;340" dur="8.8s" repeatCount="indefinite" />
          <animate attributeName="y" values="145;147;143;145" dur="7.2s" begin="0.8s" repeatCount="indefinite" />
          io
        </text>

        {/* Lower middle layer */}
        <circle cx="150" cy="180" r="14" fill="#4b5563">
          <animate attributeName="cx" values="150;148;152;150" dur="8s" repeatCount="indefinite" />
          <animate attributeName="cy" values="180;182;178;180" dur="7.5s" begin="1.2s" repeatCount="indefinite" />
        </circle>
        <text x="150" y="185" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="150;148;152;150" dur="8s" repeatCount="indefinite" />
          <animate attributeName="y" values="185;187;183;185" dur="7.5s" begin="1.2s" repeatCount="indefinite" />
          fn
        </text>

        <circle cx="250" cy="180" r="14" fill="#06b6d4">
          <animate attributeName="cx" values="250;248;252;250" dur="9s" repeatCount="indefinite" />
          <animate attributeName="cy" values="180;182;178;180" dur="8s" begin="0.9s" repeatCount="indefinite" />
        </circle>
        <text x="250" y="185" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="250;248;252;250" dur="9s" repeatCount="indefinite" />
          <animate attributeName="y" values="185;187;183;185" dur="8s" begin="0.9s" repeatCount="indefinite" />
          var
        </text>

        {/* Bottom layer */}
        <circle cx="90" cy="240" r="14" fill="#10b981">
          <animate attributeName="cx" values="90;88;92;90" dur="7.6s" repeatCount="indefinite" />
          <animate attributeName="cy" values="240;242;238;240" dur="8.4s" begin="1.1s" repeatCount="indefinite" />
        </circle>
        <text x="90" y="245" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="90;88;92;90" dur="7.6s" repeatCount="indefinite" />
          <animate attributeName="y" values="245;247;243;245" dur="8.4s" begin="1.1s" repeatCount="indefinite" />
          log
        </text>

        <circle cx="310" cy="240" r="14" fill="#ef4444">
          <animate attributeName="cx" values="310;308;312;310" dur="8.3s" repeatCount="indefinite" />
          <animate attributeName="cy" values="240;242;238;240" dur="7.7s" begin="1.4s" repeatCount="indefinite" />
        </circle>
        <text x="310" y="244" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">
          <animate attributeName="x" values="310;308;312;310" dur="8.3s" repeatCount="indefinite" />
          <animate attributeName="y" values="244;246;242;244" dur="7.7s" begin="1.4s" repeatCount="indefinite" />
          sink
        </text>

        {/* Final node */}
        <circle cx="200" cy="260" r="16" fill="#f59e0b">
          <animate attributeName="cx" values="200;198;202;200" dur="8.5s" repeatCount="indefinite" />
          <animate attributeName="cy" values="260;262;258;260" dur="7s" begin="1.5s" repeatCount="indefinite" />
        </circle>
        <text x="200" y="264" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold">
          <animate attributeName="x" values="200;198;202;200" dur="8.5s" repeatCount="indefinite" />
          <animate attributeName="y" values="264;266;262;264" dur="7s" begin="1.5s" repeatCount="indefinite" />
          query
        </text>

        {/* Isolated nodes without edges */}
        <circle cx="30" cy="80" r="12" fill="#4b5563" opacity="0.7">
          <animate attributeName="cx" values="30;28;32;30" dur="8.2s" repeatCount="indefinite" />
          <animate attributeName="cy" values="80;82;78;80" dur="7.3s" begin="0.6s" repeatCount="indefinite" />
        </circle>
        <text x="30" y="84" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">
          <animate attributeName="x" values="30;28;32;30" dur="8.2s" repeatCount="indefinite" />
          <animate attributeName="y" values="84;86;82;84" dur="7.3s" begin="0.6s" repeatCount="indefinite" />
          fn
        </text>

        <circle cx="370" cy="100" r="12" fill="#06b6d4" opacity="0.7">
          <animate attributeName="cx" values="370;368;372;370" dur="7.8s" repeatCount="indefinite" />
          <animate attributeName="cy" values="100;102;98;100" dur="8.6s" begin="1.2s" repeatCount="indefinite" />
        </circle>
        <text x="370" y="104" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">
          <animate attributeName="x" values="370;368;372;370" dur="7.8s" repeatCount="indefinite" />
          <animate attributeName="y" values="104;106;102;104" dur="8.6s" begin="1.2s" repeatCount="indefinite" />
          util
        </text>

        <circle cx="20" cy="220" r="12" fill="#10b981" opacity="0.7">
          <animate attributeName="cx" values="20;18;22;20" dur="8.9s" repeatCount="indefinite" />
          <animate attributeName="cy" values="220;222;218;220" dur="7.1s" begin="0.9s" repeatCount="indefinite" />
        </circle>
        <text x="20" y="224" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">
          <animate attributeName="x" values="20;18;22;20" dur="8.9s" repeatCount="indefinite" />
          <animate attributeName="y" values="224;226;222;224" dur="7.1s" begin="0.9s" repeatCount="indefinite" />
          cfg
        </text>

        <circle cx="375" cy="220" r="12" fill="#f59e0b" opacity="0.7">
          <animate attributeName="cx" values="375;373;377;375" dur="7.4s" repeatCount="indefinite" />
          <animate attributeName="cy" values="220;222;218;220" dur="8.2s" begin="1.7s" repeatCount="indefinite" />
        </circle>
        <text x="375" y="224" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">
          <animate attributeName="x" values="375;373;377;375" dur="7.4s" repeatCount="indefinite" />
          <animate attributeName="y" values="224;226;222;224" dur="8.2s" begin="1.7s" repeatCount="indefinite" />
          test
        </text>
      </g>
    </svg>
  );
}
